import {useMemo} from 'react'

import {useIsHydrated} from '@vio/core/src/utils/react/hooks/useIsHydrated'

import {readDealFreezeStash} from '../utils/stash'

/**
 * Reads the `offerId` from the Deal Freeze stash, if any. Returns `undefined`
 * on the server or when there's no pending stash.
 *
 * Used by AP views to look up AP-side analytics context for the stashed offer
 * before passing it into `useResumableDealFreeze`. Memoised on `isHydrated` so
 * the storage read + JSON parse don't run on every render. The value is a
 * hydration-time snapshot: it does not update when the stash is later cleared,
 * so consumers must gate on `resumableDealFreezeReady`, not on this value.
 */
export const useStashedOfferId = (): string | undefined => {
  const isHydrated = useIsHydrated()
  return useMemo(() => {
    if (!isHydrated) return undefined
    return readDealFreezeStash()?.offerId
  }, [isHydrated])
}
